module.exports = __webpack_public_path__ + "img/date_time.6526b4a2.svg";